function createIdRandom() {
  return {
    id: Math.random(),
  }
}

export { createIdRandom }
